import React, { useState, useEffect } from "react";
import Modal from "shared/Modal/Modal";
import formatNumber from "../../../../helpers/NumberFormat";
import moment from "moment";
import {
  useUpdateExecutionDateTransactionMutation,
} from "services/mainApi";

const Details = ({ details, openModal, triggerModal, toast }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [executionDate, setExecutionDate] = useState("");
  const [updateTransactionExecutionDate] = useUpdateExecutionDateTransactionMutation();

  useEffect(() => {
    if (details?.execution_date) {
      setExecutionDate(details.execution_date);
    }
  }, [details]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (e) => {
    setExecutionDate(e.target.value);
  };

  const handleSaveTransactionClick = async (id, status_id) => {
    setIsEditing(false);
    const result = await updateTransactionExecutionDate({
      id: details?.id,
      execution_date: executionDate,
    });

    if ("error" in result) {
      console.log("error");
    } else {
      toast.success("Transaction date updated successfully.");
      triggerModal()
    }
  };

  return (
    <div>
      <Modal open={openModal} handleCancel={triggerModal}>
        <div className="w-100 bg-primary-custom d-flex justify-content-between text-white">
          <h4 className="p-4">Transaction {details?.id} Details</h4>
          <div className="p-4">
            <h5>{moment(details?.created_at).format("DD/MM/YYYY")}</h5>
          </div>
        </div>
        <div className="mt-5 m-auto w-75 text-center shadow-sm p-4">
          {details?.type === "out" ? (
            <div>
              <div className="d-flex gap-3 w-100">
                <div className="w-50 text-start">
                  <h5 className="text-dark">Requested Amount:</h5>
                </div>
                <div className="w-50 text-start text-dark">
                  <h6>{formatNumber(details.amount)} €</h6>
                </div>
              </div>
              <div className="d-flex justify-content-center gap-3 w-100 border-bottom">
                <div className="w-50 text-start">
                  <h5 className="text-dark">
                    Transaction Fee:
                  </h5>
                </div>
                <div className="w-50 text-start text-dark">
                  <h6 className="w-25">
                    {formatNumber(details?.outgoing_fee) + "€"}
                  </h6>
                </div>
              </div>
              <div className="gap-3 mt-4">
                <div className="w-50 text-start">
                  <h6 className="text-dark fw-bold">Notes</h6>
                </div>
                <div className="w-50 text-start mt-1">
                  <h6>{details?.description}</h6>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-center gap-3">
                <div className="w-50 text-start">
                  <h5 className="text-green">Credit:</h5>
                </div>
                <div className="w-50 text-start">
                  <h5>{formatNumber(details?.amount)}€</h5>
                </div>
              </div>
              <div className="gap-3 mt-4">
                <div className="w-50 text-start">
                  <h6 className="text-dark fw-bold">Notes</h6>
                </div>
                <div className="w-50 text-start mt-1">
                  <h6>{details?.description}</h6>
                </div>
              </div>
            </>
          )}
          <br></br>
          <div className="d-flex justify-content-center gap-3">
            <div className="w-50 text-start">
              <h5 className="text-grey">Bank Name:</h5>
            </div>
            <div className="w-50 text-start">
              <h5>{details?.bank_name}</h5>
            </div>
          </div>
          <div className="d-flex justify-content-center gap-3">
            <div className="w-50 text-start">
              <h5 className="text-grey">BIC/SWIFT:</h5>
            </div>
            <div className="w-50 text-start">
              <h5>{details?.swift_code}</h5>
            </div>
          </div>
          <div className="d-flex justify-content-center gap-3">
            <div className="w-50 text-start">
              <h5 className="text-grey">IBAN:</h5>
            </div>
            <div className="w-50 text-start">
              <h5>{details?.iban}</h5>
            </div>
          </div>
          <div className="d-flex justify-content-center gap-3">
            <div className="w-50 text-start">
              <h5 className="text-grey">Benificary Name:</h5>
            </div>
            <div className="w-50 text-start">
              <h5>{details?.beneficary_name}</h5>
            </div>
          </div>
          {/* <div className="d-flex justify-content-center gap-3">
            <div className="w-50 text-start">
              <h5 className="text-grey">Benificary Address:</h5>
            </div>
            <div className="w-50 text-start">
              <h5>{details?.beneficary_address}</h5>
            </div>
          </div> */}
          <div className="d-flex justify-content-center gap-3">
            <div className="w-50 text-start">
              <h5 className="text-grey">Benificary Country:</h5>
            </div>
            <div className="w-50 text-start">
              <h5>{details?.beneficary_country}</h5>
            </div>
          </div>
          <div className="d-flex justify-content-center gap-3">
            <div className="w-50 text-start">
              <h5 className="text-grey">TRN:</h5>
            </div>
            <div className="w-50 text-start">
              <h5>{details?.trn_nr}</h5>
            </div>
          </div>
          <br></br>
          <div className="d-flex justify-content-center gap-3">
            <div className="w-50 text-start">
              <h5 className="text-grey">Created Date:</h5>
            </div>
            <div className="w-50 text-start">
              <h5>{moment(details?.created_at).format("YYYY-MM-DD HH:mm:ss")}</h5>
            </div>
          </div>
          <div className="d-flex justify-content-center gap-3">
            <div className="w-50 text-start">
              <h5 className="text-grey">Client sees this date:</h5>
            </div>
            <div className="w-50 text-start">
              {isEditing ? (
                <input
                  type="datetime-local"
                  className="form-control"
                  value={executionDate}
                  onChange={handleInputChange}
                />
              ) : (
                <h5>
                  {executionDate
                    ? moment(executionDate).format("YYYY-MM-DD HH:mm:ss")
                    : "Date not available"}
                </h5>
              )}

              <div className="mt-3">
                {isEditing ? (
                  <button className="btn btn-success" onClick={handleSaveTransactionClick}>
                    Save Client Transaction Date
                  </button>
                ) : (
                  <button className="btn btn-primary" onClick={handleEditClick}>
                    Edit Client Transaction Date
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Details;
